export default __webpack_public_path__ + "static/media/thx.565e6768.png";